import { Behavior } from "../../base/Behavior";
import { ToolsTableCell } from "./ToolsTableCell";
import { Button } from "../button/Button";
import { TableRowMode } from "./TableRowMode";
import { ButtonProps } from "../button/ButtonProps";
import { ToolsTableCellViewer } from "./ToolsTableCellViewer";
import { Component } from "../../base/Component";

export class ToolsTableCellBehavior extends Behavior {
    protected constructor() {
        super();
    }

    manageToolsCellWidth(cell: ToolsTableCell, cellWidth: number): void {
        cell.fixedWidth = cellWidth;
        cell.table.toolsCellAdded(cellWidth);
    }

    shouldAddDragHandler(cell: ToolsTableCell): boolean {
        return cell.row.mode !== TableRowMode.SEARCH && cell.table.sequenceField != null;
    }

    shouldAddSlideoutButton(cell: ToolsTableCell): boolean {
        return cell.row.allowEdit === true && cell.table.editLayout != null;
    }

    shouldAddDeleteButton(cell: ToolsTableCell): boolean {
        return cell.row.mode !== TableRowMode.SEARCH && cell.row.allowDelete;
    }

    get deleteButtonProps(): Partial<ButtonProps> {
        return { themeKey: "tableRow.deleteButton", rowBreak: false, focusable: true }
    }

    setupToolCellPanel(
        cell: ToolsTableCell, ellipsisButton: Button, viewer: ToolsTableCellViewer, tools: Component[]
    ): void {
        cell.toolsPanel.add(ellipsisButton);
    }

    get type(): string {
        return "ToolsTableCell";
    }
}

ToolsTableCellBehavior.register();
